module.exports = __webpack_public_path__ + "img/logo_pautions.d884e53e.svg";